// @flow

/**
 * Gets the integer values of a 6-digit CSS hex color's red, green, and blue components.
 *
 * @param hexColor - A 6-digit CSS hex color
 * @return The red, green, and blue components of the hex color as numbers
 */
const getHexColorComponents = (hexColor: string): { red: number, green: number, blue: number } => ({
  red: parseInt(hexColor.substr(1, 2), 16),
  green: parseInt(hexColor.substr(3, 2), 16),
  blue: parseInt(hexColor.substr(5, 2), 16),
});

export default getHexColorComponents;
